import e from "./internal/_curry2.mjs";
import f from "./map.mjs";
var p = /* @__PURE__ */ e(function(n, t) {
  return function(u) {
    return function(r) {
      return f(function(o) {
        return t(o, r);
      }, u(n(r)));
    };
  };
});
export {
  p as default
};
